import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


// IMPORT GUARD FILES

import { AuthGuard } from '../../auth.guard';
import { ModuleGuard } from '../../permission.guard';
import { Role } from '../../_models/role';
import { Permission } from '../../_models/permission';


// IMPORT JOB MODULE COMPONENTS
import { MainFolderModuleComponent } from './main-folder.component';
import { SingleFolderComponent } from '../single-folder/single-folder.component';


const routes: Routes = [
  {
    path: '',
    component: MainFolderModuleComponent,
    children: [
      {
        path: 'list',
        component: SingleFolderComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Trainer, Role.Client, Role.Mp, Role.Staff, Role.IQA, Role.Operative, Role.Manager], permission: [Permission.MyDocs] }
      },
      {
        path: 'single-folder/:id',
        component: SingleFolderComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Trainer, Role.Client, Role.Mp, Role.Staff, Role.IQA, Role.Operative, Role.Manager], permission: [Permission.MyDocs] }
      },
      {
        path: 'single-folder/:folderId/:userId/:fileId',
        component: SingleFolderComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Trainer, Role.Client, Role.Mp, Role.Staff, Role.IQA, Role.Operative, Role.Manager], permission: [Permission.MyDocs] }
      },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainFolderModuleRoutingModule { }
